import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export const minDoB = new Date(1900, 1, 1); // All birthdays need to be after this date.

export const contentfulOptions = {
	renderText: text =>
		text
			.split('\n')
			.reduce(
				(children, textSegment, index) => [
					...children,
					index > 0 && <br key={textSegment} />,
					textSegment,
				],
				[]
			),
	renderNode: {
		table: (node, children) => (
			<TableContainer>
				<Table>
					<TableBody>{children}</TableBody>
				</Table>
			</TableContainer>
		),
		'table-row': (node, children) => <TableRow>{children}</TableRow>,
		'table-cell': (node, children) => <TableCell>{children}</TableCell>,
		'asset-hyperlink': node => (
			<Link href={node.data.target.file.url} target="_blank" rel="noopener">
				{node.data.target.title}
			</Link>
		),
		'unordered-list': (node, children) => (
			<Typography color="text.secondary" component="ul">
				{children}
			</Typography>
		),
	},
};
